module.exports = __webpack_public_path__ + "img/corp_cchst.90c4d797.svg";